import { render, staticRenderFns } from "./SearchSummaryList.vue?vue&type=template&id=1b93ad72"
import script from "./SearchSummaryList.vue?vue&type=script&lang=js"
export * from "./SearchSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports